const SNACKBAR_OPEN = 'SNACKBAR_OPEN';
const SNACKBAR_CLOSE = 'SNACKBAR_CLOSE';
const BACKDROP_OPEN = 'BACKDROP_OPEN';
const BACKDROP_CLOSE = 'BACKDROP_CLOSE';

export const snackBar = {
  SNACKBAR_OPEN,
  SNACKBAR_CLOSE,
  BACKDROP_OPEN,
  BACKDROP_CLOSE,
};
